import React from "react";
import { DateRangeRounded } from "@mui/icons-material";
import { useOutletContext } from "react-router-dom";
import {
  Box,
  Chip,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import DocumentGeneralJournalAccrualReversalActions from "./DocumentGeneralJournalAccrualReversalActions";
import TablePreloader from "../adjusting-entries/TablePreloader";

const DocumentAccrualReversalAllBatch = ({ data, isFetching }) => {
  const { handleViewAllEntries, handleManageAllEntries } = useOutletContext();
  return (
    <Box width={1}>
      <Stack direction="row">
        <TableContainer className="FstoTableContainer-root">
          <Table className="FstoTable-root" size="small">
            <TableHead className="FstoTableHead-root">
              <TableRow className="FstoTableRow-root">
                <TableCell className="FstoTableCell-root FstoTableCell-head FstoTabCell-color">
                  YEAR
                </TableCell>
                <TableCell className="FstoTableCell-root FstoTableCell-head FstoTabCell-color">
                  SUPPLIERS
                </TableCell>
                <TableCell className="FstoTableCell-root FstoTableCell-head FstoTabCell-color">
                  COMPANIES
                </TableCell>
                <TableCell
                  className="FstoTableCell-root FstoTableCell-head FstoTabCell-color"
                  align="right"
                >
                  ACTIONS
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody className="FstoTableBody-root">
              {!isFetching &&
                Object.keys(data).map((value, index) => (
                  <TableRow className="FstoTableRow-root" key={index + value} hover>
                    <TableCell className="FstoTableCell-root FstoTableCell-body">
                      <Stack direction="row" alignItems="center" gap={0.55}>
                        <DateRangeRounded sx={{ opacity: 0.7 }} />
                        <Typography className="FstoTypography-general_journal">{value}</Typography>
                      </Stack>
                    </TableCell>
                    <TableCell className="FstoTableCell-root FstoTableCell-body">
                      <Stack direction="row" alignItems="center" gap={1}>
                        {Array.from(new Set(data[value]?.map((item) => item.supplier.name)))
                          .slice(0, 3)
                          .map((item) => (
                            <Typography className="FstoTypography-general_journal">
                              {item}
                            </Typography>
                          ))}
                        {Array.from(new Set(data[value]?.map((item) => item.supplier.name)))
                          .length > 1 && (
                          <Chip
                            label={`+${
                              Array.from(new Set(data[value]?.map((item) => item.supplier.name)))
                                .length - 1
                            } others`}
                            size="small"
                          />
                        )}
                      </Stack>
                    </TableCell>
                    <TableCell className="FstoTableCell-root FstoTableCell-body">
                      <Stack direction="row" alignItems="center" gap={1}>
                        {Array.from(new Set(data[value]?.map((item) => item.company.name)))
                          .slice(0, 3)
                          .map((item) => (
                            <Typography className="FstoTypography-general_journal">
                              {item}
                            </Typography>
                          ))}
                        {Array.from(new Set(data[value]?.map((item) => item.company.name))).length >
                          1 && (
                          <Chip
                            label={`+${
                              Array.from(new Set(data[value]?.map((item) => item.company.name)))
                                .length - 1
                            } others`}
                            size="small"
                          />
                        )}
                      </Stack>
                    </TableCell>
                    <TableCell className="FstoTableCell-root FstoTableCell-body" align="right">
                      <DocumentGeneralJournalAccrualReversalActions
                        data={value}
                        onView={handleViewAllEntries}
                        onManage={handleManageAllEntries}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              {isFetching && <TablePreloader />}
            </TableBody>
          </Table>
        </TableContainer>
      </Stack>
    </Box>
  );
};

export default DocumentAccrualReversalAllBatch;
